export interface SampleDataField {
  key: string
  value: any
}

export type SampleCustomProps = {
  _id: string | undefined
  _typeSample: string
  _sampleData: SampleDataField[]
}

export class SampleCustom {
  _id: string | undefined
  _typeSample: string
  _sampleData: SampleDataField[]

  constructor(p: SampleCustomProps) {
    this._id = p._id
    this._typeSample = p._typeSample
    this._sampleData = p._sampleData
  }

  get id(): string | undefined { return this._id }
  set id(value: string | undefined) { this._id = value }
  get typeSample(): string { return this._typeSample }
  set typeSample(value: string) { this._typeSample = value }
  get sampleData(): SampleDataField[] { return this._sampleData }
  set sampleData(value: SampleDataField[]) { this._sampleData = value }

  getFieldValue(key: string): any {
    const field = this._sampleData.find(f => f.key === key)
    return field?.value
  }

  setFieldValue(key: string, value: any): void {
    const existing = this._sampleData.find(f => f.key === key)
    if (existing) {
      existing.value = value
    } else {
      this._sampleData.push({ key, value })
    }
  }
}
